module.exports = __webpack_public_path__ + "static/media/download.0c9817c8.svg";